import { render, staticRenderFns } from "./ResourceItemDb.vue?vue&type=template&id=27194372"
import script from "./ResourceItemDb.ts?vue&type=script&lang=ts&external"
export * from "./ResourceItemDb.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports